/**
 * 订单相关接口
 */
import { httpMgr } from '../../common/network/httpMgr';
import { ApiEnums } from '../../constants/apiConstants';

export type ReqRequestBuyList = {
  userNewId?: number | string; // 用户id
  pageNum: number;
  pageSize: number;
  activityId?: string;
  needTwoWheelOrder: boolean;
  showStatus?: string;
  sceneCode?: string;
  subSceneCode?: string;
  filterClosedOrder?: boolean;
}
// 购买记录列表
export async function requestBuyList(params: ReqRequestBuyList) {
  const res = await httpMgr.request(ApiEnums.GET_BUY_LIST, params);
  const list = res.data;
  if (list && list.length) {
    list.forEach((item: any) => {
      if (item && item.picUrl && item.picUrl.indexOf('https') < 0) {
        item.picUrl = item.picUrl.replace('http', 'https');
      }
    });
  }
  return res;
}

export type ReqRequestBuyDetail = {
  orderId: string; // 订单编号
}
// 购买订单详情
export async function requestBuyDetail(params: ReqRequestBuyDetail) {
  const res = await httpMgr.request(ApiEnums.GET_BUY_DETAIL, params);
  const item = res.data;
  if (item && item.picUrl && item.picUrl.indexOf('https') < 0) {
    item.picUrl = item.picUrl.replace('http', 'https');
  }
  return res;
}

export type RequestGetJumpLinkParams = {
  categoryId: string; // 订单编号
}
// 获取跳转链接
export async function requestGetJumpLink(params: RequestGetJumpLinkParams) {
  const res = await httpMgr.request(ApiEnums.GET_JUMP_LINK, params);
  return res.data || {};
}

// 获取去使用外部跳转链接
export async function requestGetUseOutJumpLink(params: RequestGetJumpLinkParams) {
  const res = await httpMgr.request(ApiEnums.OUT_USE_URL, params);
  return res.data || {};
}

// 用户自主退款接口
export type RefundOrderParams = {
  orderNo: string;
}
export function refundOrder(params: RefundOrderParams) {
  return httpMgr.request(ApiEnums.CUSTOM_REFUND, {
    ...params,
  });
}

/**
 * 取消订单
 * @ref https://yapi.hellobike.cn/project/6782/interface/api/433586
 */
export function cancelOrder(params: { orderId: string; userNewId: number }) {
  return httpMgr.request(ApiEnums.ORDER_DECLINE, params);
}

export default {};
